<template>
    <div>
        <template v-if="model.uuid">
            <strong>受付番号</strong>
            {{ model.meta.text.number }}
            {{ model.name }}
            {{ model.meta.text.status }}
        </template>

        <div class="row pgb p-0 mt-3">
            <div
                class="col step p-0"
                v-for="(option, index) in options_array"
                :key="option.value"
                :class="option.status"
                >
                <p class="img-step">{{ index + 1}}</p>
                <span class="img-circle"></span>
                <p class="step-title">{{ option.name }}</p>
            </div>
        </div>

        <div class="pb-5" v-if="model.uuid">
            {{ trans.messages[`info.items.status.${model.status}`] }}
<!--
            {{ trans.messages[`info.form_answers.status.${model.status}`] | baseTransFormatter({ number: model.meta.text.number }) }}
-->
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
        options: {
            type: Object,
            required: true,
            default() {
                return {
                    normal: [],
                    cancel: [],
                }
            },
        },
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
    },
    computed: {
        ...mapGetters([
            'trans',
        ]),
        options_array: {
            get() {
                let options = Object.assign({}, this.options)
                if ([ 'canceling', 'canceled', ].indexOf(this.model.status) >= 0) {
                    options = options.cancel
                } else {
                    options = options.normal
                }
                let value_index = 0
                options.find((option, index) => {
                    if (option.value === this.model.status) {
                        value_index = index
                        return true
                    }
                })
                options.forEach((value, index) => {
                    value.status = ''
                    if (index < value_index) {
                        value.status = 'complete'
                    } else if (index === value_index) {
                        value.status = 'active'
                    }
                    options[index] = value
                })
                return options
            },
        },
    },
    data() {
        return {}
    },
    async mounted() {},
    methods: {
    },
}
</script>

<style lang="scss" scoped>
body {
    font-family: 'Open Sans', sans-serif;
    font-size:.9rem;
    color:#607D8B;
}
.pgb .step {
    text-align: center;
    position:relative;
}
.pgb h2 {
    font-size:1.3rem;
}
.pgb .step .step-description {
}
.pgb .step p.img-step {
    display: none;
    /*
    position:absolute;
    height:60px;
    width:100%;
    text-align:center;
    display:block;
    z-index:3;
    color:#fff;
    font-size:160%;
    line-height:55px;
    opacity:.7;
    */
}
.pgb .active.step p {
    opacity:1;
    font-weight:600;
}
.pgb .img-circle {
    font-family: 'Open Sans', sans-serif;
    display: inline-block;
    /*
    width: 60px;
    height: 60px;
    */
    width: 30px;
    height: 30px;
    border-radius:50%;
    background-color:#e2e3e5;
    border:4px solid #fff;
}
.pgb .complete .img-circle {
    background-color:#b8daff;
}
.pgb .active .img-circle {
    background-color:#007bff;
}
.pgb .step .img-circle:before,
.pgb .step .img-circle:after {
    content: "";
    display: block;
    background: #e2e3e5;
    /*
    height: 4px;
    */
    height: 2px;
    width: 50%;
    position: absolute;
    /*
    bottom: 50%;
    */
    top: 15px;
    left: 0;
    z-index: -1;
}
.pgb .step .img-circle:before {
    margin-right:24px;
}
.pgb .step .img-circle:after {
    left: 50%;
}
.pgb .step.active .img-circle:after {
    background: #e2e3e5;
}

.pgb .step.complete .img-circle:before,
.pgb .step.complete .img-circle:after,
.pgb .step.active .img-circle:before {
    background: #b8daff;
}
.pgb .step.active:last-of-type .img-circle:after {
    background: #b8daff;
}
/*
.pgb .step:last-of-type .img-circle:after,
.pgb .step:first-of-type .img-circle:before{
    display: none;
}
*/
</style>

